

export function toBase64(arr) {
    if (Array.isArray(arr))
        arr = new Uint8Array(arr)
    return arr ? btoa(
        arr.reduce((data, byte) => data + String.fromCharCode(byte), '')
    ) : "";
}